export class WebUtils {
  static getBrowserWidth() {
    return Math.max(
      document.body.scrollWidth,
      document.documentElement.scrollWidth,
      document.body.offsetWidth,
      document.documentElement.offsetWidth,
      document.documentElement.clientWidth,
    );
  }

  static getBrowserHeight(): number {
    if (typeof window.innerWidth === 'number') {
      return window.innerHeight;
    } else if (
      document.documentElement &&
      (document.documentElement.clientWidth || document.documentElement.clientHeight)
    ) {
      return document.documentElement.clientHeight;
    } else if (document.body && (document.body.clientWidth || document.body.clientHeight)) {
      return document.body.clientHeight;
    }
    return window.innerHeight;
  }
}
